import React from 'react';
import { Navbar, Nav, Button, Container } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Sidebar = ({ user, logout }) => {
    return (
        <div className="sidebar">
            {/* Top Section */}
            <div>
                <div className="text-center py-4">
                    <h2 className="text-white">K</h2>
                </div>
                <Navbar expand="lg" className="flex-column">
                    <Container>
                        <Nav className="flex-column">
                            {user ? (
                                <>
                                    <Nav.Link as={Link} to="/" className="text-white">
                                        Dashboard
                                    </Nav.Link>
                                    <Nav.Link as={Link} to="/create" className="text-white">
                                        Create New Survey
                                    </Nav.Link>
                                </>
                            ) : (
                                <>
                                </>
                            )}
                        </Nav>
                    </Container>
                </Navbar>
            </div>

            {/* Bottom Section */}
            {user && (
                <div className="text-center py-3">
                    {user && (
                        <div className="mt-4">
                            <p className="text-white mb-1">Welcome, {user.displayName}</p>
                        </div>
                    )}
                    <Button
                        variant="outline-light"
                        className="btn-sm"
                        onClick={logout}
                    >
                        Logout
                    </Button>
                </div>
            )}
        </div>
    );
};

export default Sidebar;